<div class="modal-body" style="height: auto !important">
  <div id="history-content">
    <div class="container user_history">
      <div class="invoice_history">
        Invoice History
        <div id="view-history">
          <input id="history-table-filters" class="history-table-filter form-control" type="text" placeholder="Search"
            name="search" [(ngModel)]="search" />
        </div>
      </div>
      <button class="endPoint btn ntn-default hide btn-success" name="invoices" *ngIf="!isLoaded">
        invoices
      </button>
      <div id="historyloadingText" class="h5" *ngIf="!isLoaded">Loading...</div>
      <div id=" response_history table-responsive">
        <table id="users-history" class="history-table">
          <tbody>
            <tr *ngFor="let inv of invoiceData | filter: search; index as i">
              <ng-container *ngIf="(i >= start && i <end) || search">
                <td>
                  <a target="_blank" href="{{url}}/account/invoices/{{
                      inv.invoice_number.content
                    }}?ht={{ hostedToken }}">{{ inv.invoice_number.content }}</a>
                </td>
                <td>
                  ${{ inv.total_in_cents.content / 100
                  }}<span class="span"></span>
                </td>
                <td *ngIf="!inv.line_items.adjustment.length">
                  {{ inv.line_items.adjustment.quantity.content }} item
                </td>
                <td *ngIf="inv.line_items.adjustment.length">
                  {{ inv.line_items.adjustment.length }} item
                </td>
                <td>{{ inv.created_at.content | date: "shortDate" }}</td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-container" *ngIf="isLoaded">
        <div class="show">
          Show
          <select name="state " id="max-Row " class="form-control" class="select" (change)="paginatorChange($event)"
            [(ngModel)]="showResults">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="500">All</option>
          </select>
          per page
        </div>
        <nav style="float: right">
          <ul class="pagination">
            <ng-container *ngFor="let data of invoiceData; index as j">
              <li data-page="j / showResults + 1" class="active" *ngIf="j % showResults === 0">
                <span style="background-color: transparent; border: none" (click)="changePage(j / showResults)"
                  [ngClass]="
                    j % showResults === 0 && active[j / showResults] === true
                      ? 'sr-only'
                      : ''
                  ">{{ j / showResults + 1 }}</span>
              </li>
            </ng-container>
          </ul>
        </nav>
      </div>
    </div>
  </div>
  <div class="btn_div">
    <button type="button " class="btn gernal-btn" (click)="closeModal()">
      OK
    </button>
  </div>
</div>